__turbopack_context__.v({
  "content": "accordion-module-scss-module__OhpmyW__content",
  "content-animation": "accordion-module-scss-module__OhpmyW__content-animation",
  "item": "accordion-module-scss-module__OhpmyW__item",
  "slide-down": "accordion-module-scss-module__OhpmyW__slide-down",
  "slide-up": "accordion-module-scss-module__OhpmyW__slide-up",
  "trigger": "accordion-module-scss-module__OhpmyW__trigger",
});
